"use client";

import { useGoogleAuthStore, type GoogleAuthState } from "@/stores";

export type { GoogleAuthState };

export const useGoogleAuth = (): GoogleAuthState => useGoogleAuthStore();
